import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "search-result-box"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "poster-box" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "info" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "tags" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "series" }


import debounce from 'lodash/debounce'
import { store } from '@remote/store'
import { useCinemaStore } from '@remote/store/cinema'
import { useCinemaSearch, TSearchResourceRetItem } from '@remote/store/cinemaSearch'
import { toast } from '@remote/utils'
import { openCinemaSeries} from '@remote/utils/dialog'
import CinemaSearchListEmpty from '@remote/components/cinema/CinemaSearchListEmpty.vue'
import Loading from '@remote/components/Loading.vue'
import LoadMore from '@remote/components/LoadMore.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    type: null
  },
  emits: ['clickTvItem'],
  setup(__props: any, { emit }) {




const cinemaStore = useCinemaStore()
const { data, searchScrape, abnormal } = useCinemaSearch()
const loadMore = () => {
  searchScrape()
}

const handleOnClickSearchItem = debounce((episode: TSearchResourceRetItem) => {
  if (episode.id) {
    if (episode.isTV) {
      const params = {
        nfo: {
          video_info: episode ,
          scrape_result: episode.scrape_info,
        },
      }
      openCinemaSeries(params as  API_NFO.NFO)
      emit('clickTvItem')
    } else {
      const apiUrl = episode.isOther ? '/drive/v2/files' : '/drive/v1/files'
      const scene = episode.isOther ? 'heziFile': 'nfo'
      store.dispatch('getFileInfo', {
        space: 'hezi',
        apiUrl,
        path: episode?.file_path || '',
        size: String(episode?.file_size),
        id: episode.id,
        hash: episode.hash,
        usage: 'PLAY',
        theme: 'dark',
        scene,
        mime_type: 'video/*',
        name: episode.name,
      }).then(() => {
        cinemaStore.refreshRecentNFOList()
      }).catch(() => {
        toast('播放失败，请检查文件是否存在')
      }).finally(() => {
        cinemaStore.setPlaying(false)
      })
    }
  } else {
    toast('播放失败，请检查文件是否存在')
  }
}, 500, {
  leading: true,
  trailing: false,
})

return (_ctx: any,_cache: any) => {
  const _directive_see = _resolveDirective("see")!

  return (_unref(data).filesIds[__props.type].length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).filesIds[__props.type], (id) => {
          return (_openBlock(), _createElementBlock("div", {
            key: id,
            class: _normalizeClass(["search-result-item", {other: _unref(data).map[id]?.isOther}]),
            onClick: ($event: any) => (_unref(handleOnClickSearchItem)(_unref(data).map[id]))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                class: "poster",
                src: _unref(data).map[id]?.postUrl
              }, null, 8, _hoisted_4)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("h4", {
                  innerHTML: _unref(data).map[id]?.displayName
                }, null, 8, _hoisted_6),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", null, _toDisplayString(_unref(data).map[id].displayClass), 1),
                  (_unref(data).map[id]?.year)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(data).map[id]?.year), 1))
                    : _createCommentVNode("", true),
                  (_unref(data).map[id]?.originPlace)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(data).map[id]?.originPlace), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(data).map[id]?.displayEpisode), 1)
            ])
          ], 10, _hoisted_2))
        }), 128)),
        (_unref(data).class === __props.type && !!_unref(data).hasMore[__props.type] && !_unref(data).loading[__props.type])
          ? _withDirectives((_openBlock(), _createBlock(LoadMore, {
              key: 0,
              onClick: loadMore
            }, null, 512)), [
              [_directive_see, loadMore]
            ])
          : _createCommentVNode("", true)
      ]))
    : (_unref(data).class === __props.type && _unref(data).loading[__props.type])
      ? (_openBlock(), _createBlock(Loading, { key: 1 }))
      : (_openBlock(), _createBlock(CinemaSearchListEmpty, {
          key: 2,
          type: _unref(abnormal).type,
          message: _unref(abnormal).errorMessage
        }, null, 8, ["type", "message"]))
}
}

})